import React, { useContext, useMemo } from 'react';
import { GlobalStateDataContext } from '../../context-api/data-provider/GlobalStateDataProvider';
import './onboarding-pending-review.scss';

function isOnboardingFlagTrue(value) {
  return value === true || value === 'true';
}

const CheckIcon = () => (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none'>
    <path
      d='M5 12.5L9.5 17L19 7'
      stroke='white'
      strokeWidth='2.2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const CheckMiniIcon = () => (
  <svg width='11' height='11' viewBox='0 0 11 11' fill='none'>
    <path
      d='M1.5 5.5L4.5 8.5L9.5 2.5'
      stroke='white'
      strokeWidth='1.6'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const OnboardingPendingReview = () => {
  const { onLoadInfoResponse } = useContext(GlobalStateDataContext);

  const menuVerified = useMemo(() => {
    const status =
      onLoadInfoResponse?.data?.data?.data?.kitchenOperationObject?.onborading_status ?? {};
    return isOnboardingFlagTrue(status.menu_verified);
  }, [onLoadInfoResponse]);

  return (
    <div className='ob-pr-page'>
      <div className='ob-pr-card'>

        {/* ── Hero ── */}
        <div className='ob-pr-hero'>
          <div className='ob-pr-title-row'>
            <div className='ob-pr-title-row__left'>
              <div className='ob-pr-hero__icon'><CheckIcon /></div>
              <h1 className='ob-pr-title'>You&apos;re all set!</h1>
            </div>
            <div className='ob-pr-badge'>
              <span className='ob-pr-badge__dot' />
              In Review
            </div>
          </div>
          <p className='ob-pr-desc'>
            Your account is now under review — typically <strong>15–20 days</strong>. Once
            approved, an account manager will personally deliver your tablet and walk you through
            every feature.
          </p>
        </div>

        {/* ── Steps ── */}
        <div className='ob-pr-steps'>
          <div className='ob-pr-step ob-pr-step--done'>
            <div className='ob-pr-step__dot'>
              <CheckMiniIcon />
            </div>
            <div>
              <p className='ob-pr-step__label'>Documents submitted</p>
              <p className='ob-pr-step__desc'>EIN &amp; menu uploaded successfully</p>
            </div>
          </div>

          <div
            className={`ob-pr-step ${menuVerified ? 'ob-pr-step--done' : 'ob-pr-step--active'}`}
          >
            <div className='ob-pr-step__dot'>
              {menuVerified ? <CheckMiniIcon /> : '2'}
            </div>
            <div>
              <p className='ob-pr-step__label'>Account review in progress</p>
              <p className='ob-pr-step__desc'>
                {menuVerified
                  ? 'Your information has been verified'
                  : 'Our team is verifying your information'}
              </p>
            </div>
          </div>

          <div
            className={`ob-pr-step ${menuVerified ? 'ob-pr-step--active' : 'ob-pr-step--pending'}`}
          >
            <div className='ob-pr-step__dot'>3</div>
            <div>
              {menuVerified ? (
                <>
                  <p className='ob-pr-step__label'>Manager assigned &amp; tablet delivered</p>
                  <p className='ob-pr-step__desc'>
                    Your manager will reach out to schedule a visit
                  </p>
                </>
              ) : (
                <>
                  <div className='ob-pr-step__label-row'>
                    <p className='ob-pr-step__label'>Manager assigned &amp; tablet delivered</p>
                    <span className='ob-pr-step__pending-badge'>Pending</span>
                  </div>
                  <p className='ob-pr-step__desc'>
                    Your manager will reach out to schedule a visit
                  </p>
                </>
              )}
            </div>
          </div>
        </div>

        {/* ── Safety ── */}
        <div className='ob-pr-safety'>
          <p className='ob-pr-safety__heading'>🔒&nbsp; Your Safety Matters</p>
          <p className='ob-pr-safety__body'>
            Your account manager will <strong>never</strong> ask for passwords or payment for your
            device. You&apos;ll see their full profile and unique ID before any visit. If anything
            seems off, contact our corporate office directly — do not share personal details with
            anyone claiming to be your manager.
          </p>
        </div>

      </div>
    </div>
  );
};

export default OnboardingPendingReview;
